import Preferences from './PreferencesContainer';

export default Preferences;